module.exports = __webpack_public_path__ + "static/media/getItDone.4e880aed.svg";